import Utils from 'services/utils';

export default class FolderSelectorController {
    /** @ngInject */
    constructor(EventEmitter, FolderService, $scope) {
        this.eventEmitter = EventEmitter;
        this.FolderService = FolderService;
        this.$scope = $scope;
    }

    $onInit() {
        this.data = this.FolderService.getTree();
        this.expandedByDefault = {};
        this.selected = {};

        if (this.preSelected && this.preSelected.length) {
            this.preSelected.forEach((folderId) => {
                this.selected[folderId] = true;
            });
            this.makePreSelectedExpanded();
        }
        this.searchIndex = this.prepareSearchIndex();

        this.$scope.$watch('$ctrl.expandSelected', (value) => {
            if (value) {
                this.collapseAll();
                Object.keys(this.selected).forEach((folderId) => {
                    this.expandFolderPath(folderId);
                });
                this.expandSelected = false;
            }
        });
    }

    expandAll() {
        this.$scope.$broadcast('angular-ui-tree:expand-all');
    }

    collapseAll() {
        this.$scope.$broadcast('angular-ui-tree:collapse-all');
    }

    makePreSelectedExpanded() {
        this.preSelected.forEach((folderId) => {
            const folderPath = this.FolderService.buildFolderPath(folderId);
            folderPath.forEach((folder) => {
                this.expandedByDefault[folder.id] = true;
            });
        });
    }

    prepareSearchIndex() {
        const data = [];
        Object.keys(this.FolderService.folderMap).forEach((folderId) => {
            const folderPath = this.FolderService.buildFolderPath(folderId);
            const name = folderPath.map(folder => folder.name).join(' > ');
            data.push({
                id: folderId,
                name
            });
        });
        return Utils.buildSearchIndex(data);
    }

    onSearch({ query }) {
        return Utils.searchInIndex(this.searchIndex, query);
    }

    onFolderFound({ item }) {
        if (item) {
            this.collapseAll();
            const folder = this.FolderService.getFolder(item.id);
            this.selectFolder(folder);
            this.expandFolderPath(folder.id);
        }
    }

    initTreeScope(scope) {
        this.treeScope = scope;
    }

    expandFolderPath(folderId) {
        if (this.treeScope.$nodesScope) {
            const folderPath = this.FolderService.buildFolderPath(folderId);
            folderPath.reduce((parentScope, folder) => {
                const childNodes = parentScope.childNodes();
                const [scope] = childNodes.filter(({ $modelValue }) => $modelValue && $modelValue.id === folder.id);
                if (scope) {
                    scope.expand();
                }
                return scope;
            }, this.treeScope.$nodesScope);
        }
    }

    selectFolder(folder, isDblClicked = false) {
        if (!this.multiSelect) {
            Object.keys(this.selected).forEach((folderId) => {
                delete this.selected[folderId];
            });
        }
        if (this.selected[folder.id]) {
            delete this.selected[folder.id];
        } else {
            this.selected[folder.id] = true;
        }
        this.changed(isDblClicked);
    }

    changed(dblClicked) {
        const eventData = {
            dblClicked
        };
        const folderIds = Object.keys(this.selected);
        if (this.multiSelect) {
            eventData.folderIds = folderIds;
        } else {
            eventData.folderId = folderIds.length ? folderIds[0] : null;
        }
        this.onChange(
            this.eventEmitter(eventData)
        );
    }
}



// WEBPACK FOOTER //
// ./app/common/tree/folder-selector/selector.controller.js